/**
 * Removes all whitespace from a value such as a vILT meeting ID.
 * Meeting IDs are often copied with display spacing ("2661 055 1806"),
 * which Aurous rejects with HTTP 400 when marking attendance.
 */
export const removeWhitespace = (value: string): string =>
    value.replace(/\s/g, '');
